const UNUSED_LINKS = [
  '/pages/pravila-akcii-0',
  '/auth/existing-customer',
  '/pages/iban-faq',
  '/kz/pages/biz-turaly',
  '/kz/pages/pogashenie-bankovskoi-kartoi',
  '/payday-loan/Применить/применить/регистрация/частное',
  '/pages/pogashenie-cherez-kassa24',
  '/pages/pogashenie-mikrokredita-cherez-onlayn-banking',
  '/pages/drugie-voprosy',
  '/pages/pogashenie-cherez-qiwi',
  '/pages/o-vozvrate',
  '/pages/documents',
  '/pages/o-mikrokredite',
  '/pages/o-tengo-kz',
  '/pages/kak-pogasit-mikrokredit',
  '/pages/prilozhenie-plus-24',
  '/pages/kak-poluchit-mikrokredit',
  '/pages/pogashenie-mikrokredita-cherez-qiwi-koshelek',
  '/uploads/Правила предоставления микрокредитов KZ.pdf',
  '/pages/pogashenie-bankovskoi-kartoi',
  '/password-recovery',
  '/uploads/Правила предоставления микрокредитов RU.pdf',
  '/kz/password-recovery',
];

export default ({ app, store, route, softRedirect }) => {
  if (UNUSED_LINKS.includes(route.fullPath)) {
    return softRedirect(app.localePath('index'));
  }

  if (store.getters['popup/popupActive']) {
    store.commit('popup/closePopup');
  }

  if (route.name && route.name.indexOf('registration-') === -1 && store.state.flow.step !== 0) {
    store.commit('flow/setPercent', '');
  }
};
